import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import { GynecologySidebar } from "../Layouts/GynecologySidebar";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class GPreviousPregnancyComplications extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      Complications: "",
      PregnancyDate: "",
      EvolutionAndTreatment: "",
      myParentTrigger: "",
      tablevaluesglobal: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".yesAnswer").click(function () {
      $(".hiddenPart").show();
    });
    $(".noAnswer").click(function () {
      $(".hiddenPart").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      console.log(this.state.tablevaluesglobal[i]["Complications"]);
      var dict = {
        Complications: this.state.tablevaluesglobal[i]["Complications"],
        PregnancyDate: this.state.tablevaluesglobal[i]["PregnancyDate"],
        EvolutionAndTreatment:
          this.state.tablevaluesglobal[i]["EvolutionAndTreatment"],

        PreviousDone: this.state.PreviousDone,
      };
      console.log(dict);

      axios
        .post(
          this.api_url+""+localStorage.getItem('currentModule')+"/complicationstable/main",
          dict,
          { headers: headers }
        )
        .then((response) => {
          console.log(response);

          if (response.status == 200) {
            $(".alert-success").show();
            $("#SubmitError").hide();
          } else {
            $(".alert-success").hide();
            $("#SubmitError").show();

            // $(response).each(function (index) {
            //     var individualResult = '<div className="card"> <div className="card-body">' + index.name + '</div> </div>'
            //     $('.resultDisplay').append(individualResult);
            // });
            // $('.resultDisplay').show();
            this.setState({ response: response.status });
            alert("sdsdad");
            // console.log(response)resultDisplay
          }
        })
        .catch((error) => {
          $(".alert-success").hide();
          $("#SubmitError").show();
          console.log(error);
        });
    }
    setTimeout(function () {
      window.location.href = "/gynecology/utilization/of/drugs";
    }, 500);
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }
  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      trimobj.Complications = data[i][0];
      trimobj.PregnancyDate = data[i][1];
      trimobj.EvolutionAndTreatment = data[i][2];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      ["Prolonged /obstructed labour", "", ""],
      ["Hypertension/ Preeclampsia/eclampsia", "", ""],
      ["Antepartum Hemorrhage", "", ""],
      ["Postpartum Hemorrhage", "", ""],
      ["Feto-maternal infection", "", ""],
      ["Diabetes", "", ""],

      // ["4th", "", ""],
    ];
    const columns = [
      "Complications",
      "Pregnancy/date ",
      "Evolution and treatment ",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { Complications, PregnancyDate, EvolutionAndTreatment } = this.state;
    return (
      <div>
        <Headers></Headers>

        <GynecologySidebar />

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Previous Pregancy Complication
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Previous Pregancy History Saved
                Successfully.
              </div>
              <div className="row pt-4">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default GPreviousPregnancyComplications;
